import { render, staticRenderFns } from "./MeasureTypeChooser.vue?vue&type=template&id=2a23270e&"
import script from "./MeasureTypeChooser.vue?vue&type=script&lang=js&"
export * from "./MeasureTypeChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports